module.exports = __webpack_public_path__ + "image/list_img3.jpg";